import React from "react";

export const AIIcon = () => {
  return (
    <svg
      width="51"
      height="26"
      viewBox="0 0 51 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="CRadioArray__recognition-empty-icon"
    >
      <rect width="51" height="26" rx="13" fill="#1E5CFB"></rect>
      <path
        d="M9.65057 18.5H8.35795L12.0966 8.31818H13.3693L17.108 18.5H15.8153L12.7727 9.92898H12.6932L9.65057 18.5ZM10.1278 14.5227H15.3381V15.6165H10.1278V14.5227ZM19.7268 8.31818V18.5H18.4939V8.31818H19.7268Z"
        fill="white"
      ></path>
      <path
        d="M33.196 12.5669L34.6511 9.90299C34.8513 9.54113 35.3671 9.54113 35.5596 9.90299L37.0148 12.5669C37.061 12.6516 37.138 12.7286 37.2227 12.7748L39.8866 14.23C40.2485 14.4301 40.2485 14.946 39.8866 15.1385L37.2227 16.5936C37.138 16.6398 37.061 16.7168 37.0148 16.8015L35.5596 19.4655C35.3594 19.8273 34.8436 19.8273 34.6511 19.4655L33.196 16.8015C33.1498 16.7168 33.0728 16.6398 32.9881 16.5936L30.3241 15.1385C29.9623 14.9383 29.9623 14.4224 30.3241 14.23L32.9881 12.7748C33.0728 12.7286 33.1498 12.6516 33.196 12.5669Z"
        stroke="white"
        stroke-width="1.2"
        stroke-miterlimit="10"
      ></path>
      <path
        d="M27.8035 8.1005L28.7126 6.43543C28.837 6.20577 29.1624 6.20577 29.2868 6.43543L30.1959 8.1005C30.2246 8.15792 30.2724 8.1962 30.3203 8.22491L31.9853 9.134C32.215 9.2584 32.215 9.58376 31.9853 9.70816L30.3203 10.6173C30.2628 10.646 30.2246 10.6938 30.1959 10.7417L29.2868 12.4067C29.1624 12.6364 28.837 12.6364 28.7126 12.4067L27.8035 10.7417C27.7748 10.6842 27.727 10.646 27.6791 10.6173L26.014 9.70816C25.7844 9.58376 25.7844 9.2584 26.014 9.134L27.6791 8.22491C27.7365 8.1962 27.7748 8.14835 27.8035 8.1005Z"
        stroke="white"
        stroke-width="1.2"
        stroke-miterlimit="10"
      ></path>
    </svg>
  );
};
